module.exports = __webpack_public_path__ + "img/icon10.484a6633.png";